(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sk9-info-tabs"] && !Shopify.designMode) return;
  try {
    
(function() {
  var sid = '{{ section.id }}';
  var wrap = document.getElementById('sk9-tabs-' + sid);
  if (!wrap) return;
  var tabs = wrap.querySelectorAll('.sk9-it__tab');
  var panels = wrap.querySelectorAll('.sk9-it__panel');
  function activate(btn) {
    tabs.forEach(function(t) { t.classList.remove('sk9-it__tab--active'); t.setAttribute('aria-selected','false'); });
    panels.forEach(function(p) { p.hidden = true; });
    btn.classList.add('sk9-it__tab--active'); btn.setAttribute('aria-selected','true');
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    if (panel) panel.hidden = false;
  }
  tabs.forEach(function(btn) {
    btn.addEventListener('click', function() { activate(btn); });
    btn.addEventListener('keydown', function(e) {
      var idx = Array.from(tabs).indexOf(btn);
      if (e.key==='ArrowRight') { e.preventDefault(); tabs[(idx+1)%tabs.length].focus(); }
      if (e.key==='ArrowLeft')  { e.preventDefault(); tabs[(idx-1+tabs.length)%tabs.length].focus(); }
      if (e.key==='Enter'||e.key===' ') { e.preventDefault(); activate(btn); }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sk9-pdp2"] && !Shopify.designMode) return;
  try {
    
(function(){
  var id='{{ section.id }}';
  var tabs=document.querySelectorAll('#sk9-tabs-'+id+' .sk9-tab');
  var panels=document.querySelectorAll('#sk9-tabs-'+id+' .sk9-tab-panel');
  if(!tabs.length)return;
  function activate(btn){
    tabs.forEach(function(t){t.classList.remove('sk9-tab--active');t.setAttribute('aria-selected','false');});
    panels.forEach(function(p){p.hidden=true;});
    btn.classList.add('sk9-tab--active');btn.setAttribute('aria-selected','true');
    var t=document.getElementById(btn.getAttribute('aria-controls'));
    if(t){t.hidden=false;t.classList.add('sk9-animate-in');}
  }
  tabs.forEach(function(btn){
    btn.addEventListener('click',function(){activate(btn);});
    btn.addEventListener('keydown',function(e){
      var i=Array.from(tabs).indexOf(btn);
      if(e.key==='ArrowRight'){e.preventDefault();tabs[(i+1)%tabs.length].focus();}
      else if(e.key==='ArrowLeft'){e.preventDefault();tabs[(i-1+tabs.length)%tabs.length].focus();}
      else if(e.key==='Enter'||e.key===' '){e.preventDefault();activate(btn);}
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
